import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Couch = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 10C26 7.794 24.206 6 22 6H10C7.794 6 6 7.794 6 10C3.794 10 2 11.794 2 14V20C2 22.206 3.794 24 6 24V25C6 25.552 6.448 26 7 26C7.552 26 8 25.552 8 25V24H24V25C24 25.552 24.448 26 25 26C25.552 26 26 25.552 26 25V24C28.206 24 30 22.206 30 20V14C30 11.794 28.206 10 26 10ZM8 10C8 8.897 8.897 8 10 8H22C23.103 8 24 8.897 24 10V10.538C22.806 11.231 22 12.523 22 14V16H10V14C10 12.523 9.194 11.231 8 10.538V10ZM28 20C28 21.103 27.103 22 26 22H6C4.897 22 4 21.103 4 20V14C4 12.897 4.897 12 6 12C7.103 12 8 12.897 8 14V17C8 17.552 8.448 18 9 18H23C23.552 18 24 17.552 24 17V14C24 12.897 24.897 12 26 12C27.103 12 28 12.897 28 14V20Z" />
	</svg>
);

export default Couch;
